import { useSelector } from 'react-redux'

import C from '../components/NotificationsDefaultSettings/constants'
import { getUserProperties } from '../selectors'

function getPropertiesValues(currentProperties: Record<string, any>) {
  const initialValues: Record<string, any> = {}
  currentProperties &&
    C.NOTIFICATION_PROPERTIES.forEach((propertyName: string) => {
      initialValues[propertyName] = currentProperties[propertyName] ?? null
    })
  return initialValues
}

export function getInitialIntegrationSettings(integrationValues: Record<string, any>) {
  return {
    topLevelFirstErrorEnabled: integrationValues?.topLevelFirstErrorEnabled,
    values: Object.entries(integrationValues)
      .filter(([key, value]) => !!value && key !== 'topLevelFirstErrorEnabled')
      .map(([key]) => key)
  }
}

export function getInitialSavedFilterValues(savedFilters: Record<string, any>[]) {
  const initialValues: Record<string, any> = {}
  savedFilters.forEach(filter => {
    initialValues[`${C.SAVED_FILTER_TYPE.PUSH}-${filter.id}`] = Boolean(
      filter.hasMobile || filter.hasDesktop
    )
    initialValues[`${C.SAVED_FILTER_TYPE.EMAIL}-${filter.id}`] = Boolean(filter.hasEmail)
  })
  return initialValues
}

export default function useFormValues(
  integrationValues: Record<string, any>[],
  savedFilters: Record<string, any>[],
  initialSubscriptions: Record<string, any>
) {
  const currentProperties = useSelector(getUserProperties)
  const initialPropertiesValues = getPropertiesValues(currentProperties)
  const initialIntegrationSettings = getInitialIntegrationSettings(integrationValues)
  const initialSavedFilterValues = getInitialSavedFilterValues(savedFilters)

  return {
    subscriptions: initialSubscriptions,
    properties: initialPropertiesValues,
    integrationSettings: initialIntegrationSettings,
    savedFilters: initialSavedFilterValues
  }
}
